import React from 'react';

import styles from './LandingHeader.module.css';

const LandingHeader = React.memo(
  (): React.ReactElement => {
    return (
      <div className={styles.landingPageHeader} data-testid="landing-header">
        <span className={styles.landingPageHeaderAppName}>
          CAE<span>Connect</span>
        </span>
      </div>
    );
  }
);

LandingHeader.displayName = 'LandingHeader';

export { LandingHeader };
